"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersGroup = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var DropdownSingleValue_1 = require("./DropdownSingleValue");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var search_1 = require("src/search");
var SearchResultsService_1 = require("../services/SearchResultsService");
var HierarchyService_1 = require("../services/HierarchyService");
var index_1 = require("../../index");
var DropdownMultipleValues_1 = require("Views/Partials/Components/DropdownMultipleValues/DropdownMultipleValues");
var DropdownOverlay_1 = require("Views/Partials/Components/DropdownOverlay/DropdownOverlay");
var FiltersGroupResetButton_1 = require("./FiltersGroupResetButton");
var hierarchyLikeFiltersAliases = [
    search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias,
    search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias,
    search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias,
    search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias,
    search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias,
    search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias,
];
var transformFilter = function (filter) { return (tslib_1.__assign(tslib_1.__assign({}, filter), { items: filter.items.map(function (item) { return ({
        selected: item.selected,
        value: item.value,
        label: (item === null || item === void 0 ? void 0 : item.extraTitle) ? item.extraTitle : item.title,
        isDisabled: item.documentsCount === 0,
    }); }) })); };
var divideFiltersToCommonAndHierarchy = function (filters, filtersGroupOrder) {
    var isHierarchyFilter = function (filter) {
        return filter.typeAlias === FilterTypings_1.FilterGroupTypeAlias.Hierarchy ||
            filter.typeAlias === FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy;
    };
    var isHierarchyLikeFilter = function (filter) {
        return hierarchyLikeFiltersAliases.indexOf(filter.value) !== -1;
    };
    return filtersGroupOrder.reduce(function (dividedFilters, filterKey) {
        var filter = filters[filterKey];
        if (!filter)
            return dividedFilters;
        if (isHierarchyFilter(filter)) {
            if (!filter.items.length)
                return dividedFilters;
            dividedFilters.hierarchyFilters[filterKey] = filter;
            dividedFilters.hierarchyFilters.totalCount++;
        }
        else if (isHierarchyLikeFilter(filter)) {
            if (!filter.items.length)
                return dividedFilters;
            dividedFilters.hierarchyLikeFilters[filterKey] = filter;
            dividedFilters.hierarchyLikeFilters.totalCount++;
        }
        else {
            dividedFilters.commonFilters[filterKey] = filter;
        }
        return dividedFilters;
    }, {
        commonFilters: {},
        hierarchyFilters: { totalCount: 0 },
        hierarchyLikeFilters: { totalCount: 0 },
    });
};
var FiltersGroup = function (_a) {
    var filters = _a.filters, filtersGroupOrder = _a.filtersGroupOrder, isDocumentsZeroResults = _a.isDocumentsZeroResults, selectedFilters = _a.selectedFilters, onChangeFilter = _a.onChangeFilter, onFiltersReset = _a.onFiltersReset, setIsResultsLoading = _a.setIsResultsLoading;
    var _b = React.useState(false), isFilterOpened = _b[0], setFilterOpened = _b[1];
    var onDropdownOpen = React.useCallback(function () {
        setFilterOpened(true);
    }, []);
    var onDropdownClose = React.useCallback(function () {
        setFilterOpened(false);
    }, []);
    var onFilterChange = React.useCallback(function (groupValue, filterValue, unselect, isSub) {
        if (isSub === void 0) { isSub = false; }
        onChangeFilter(groupValue, filterValue, unselect, isSub);
    }, [onChangeFilter]);
    var isAnyFilterSelected = React.useMemo(function () {
        return Object.keys(selectedFilters).some(function (key) { return key !== search_1.FullTextSearchFilters.TypeFilterAlias && selectedFilters[key].length > 0; });
    }, [selectedFilters]);
    var renderCommonFilters = React.useCallback(function (commonFiltersValue, filtersGroupOrderValue, selectedFiltersValue) {
        var dictionary = index_1.PageContext.dictionary;
        return filtersGroupOrderValue
            .map(function (filterKey, index) {
            var filter = commonFiltersValue[filterKey];
            if (!filter || filterKey === search_1.FullTextSearchFilters.TypeFilterAlias)
                return null;
            if (filter.newSearchGuiType === FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown) {
                var selectedValue = selectedFiltersValue[filterKey]
                    ? selectedFiltersValue[filterKey][0]
                    : '';
                return (React.createElement(DropdownSingleValue_1.DropdownSingleValue, { key: "".concat(filterKey, "-").concat(index), filter: transformFilter(filter), groupValue: filterKey, selectedValue: selectedValue, isDocumentsZeroResults: isDocumentsZeroResults, onOpen: onDropdownOpen, onClose: onDropdownClose, onFilterChange: onFilterChange, setIsResultsLoading: setIsResultsLoading }));
            }
            else if (filter.newSearchGuiType === FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti) {
                var selectedValues = selectedFiltersValue[filterKey] || [];
                return (React.createElement(DropdownMultipleValues_1.DropdownMultipleValues, { key: "".concat(filterKey, "-").concat(index), filter: transformFilter(filter), groupValue: filterKey, approvalType: dictionary.approvalType, selectedValues: selectedValues, isDocumentsZeroResults: isDocumentsZeroResults, onOpen: onDropdownOpen, onClose: onDropdownClose, onFilterChange: onFilterChange, className: 'search-dropdown', setIsResultsLoading: setIsResultsLoading }));
            }
        })
            .filter(function (f) { return f; });
    }, [isDocumentsZeroResults, onDropdownClose, onDropdownOpen, onFilterChange, setIsResultsLoading]);
    var renderHierarchyFilters = React.useCallback(function (hierarchyFiltersValue, filtersGroupOrderValue, selectedFiltersValue, renderArrows) {
        if (renderArrows === void 0) { renderArrows = true; }
        var hierarchyFilterCount = 0;
        return filtersGroupOrderValue
            .map(function (filterKey, index) {
            var filter = hierarchyFiltersValue[filterKey];
            if (!filter)
                return null;
            var selectedValue = selectedFiltersValue[filterKey]
                ? selectedFiltersValue[filterKey][0]
                : '';
            hierarchyFilterCount++;
            return (React.createElement(DropdownSingleValue_1.DropdownSingleValue, { key: "".concat(filterKey, "-").concat(index), filter: transformFilter(filter), groupValue: filterKey, selectedValue: selectedValue, isDocumentsZeroResults: isDocumentsZeroResults, isHierarchyFilter: true, onOpen: onDropdownOpen, onClose: onDropdownClose, onFilterChange: onFilterChange, customDropdownClasses: "hierarchy-filter ".concat(renderArrows && hierarchyFilterCount < hierarchyFiltersValue.totalCount
                    ? 'hierarchy-filter--has-next'
                    : '') }));
        })
            .filter(function (f) { return f; });
    }, [isDocumentsZeroResults, onDropdownClose, onDropdownOpen, onFilterChange]);
    var _c = React.useMemo(function () { return divideFiltersToCommonAndHierarchy(filters, filtersGroupOrder); }, [filters, filtersGroupOrder]), commonFilters = _c.commonFilters, hierarchyFilters = _c.hierarchyFilters, hierarchyLikeFilters = _c.hierarchyLikeFilters;
    var selectedType = React.useMemo(function () { return (0, search_1.getSelectedFilter)(selectedFilters, search_1.FullTextSearchFilters.TypeFilterAlias); }, [selectedFilters]);
    var selectedTypeValue = React.useMemo(function () { return SearchResultsService_1.SearchResultsService.getFilterValueItself(selectedType); }, [selectedType]);
    var typeWithHierarchy = React.useMemo(function () { return HierarchyService_1.HierarchyService.isSelectedTypeWithHierarchy(selectedType); }, [selectedType]);
    // render hierarchy filter to the same row, as other filters
    var specificContainerClassName = React.useMemo(function () { return (selectedTypeValue === FullTextSearchApi_1.FullTextSearcherTypes.Course ? 'container--inline' : ''); }, [selectedTypeValue]);
    var onResetClickHandler = React.useCallback(function (event) {
        event && event.stopPropagation();
        onFiltersReset();
    }, [onFiltersReset]);
    return (React.createElement("div", { className: "search-filters-group-container container" },
        React.createElement(FiltersGroupResetButton_1.FiltersGroupResetButton, { visible: isAnyFilterSelected, onResetClick: onResetClickHandler }),
        React.createElement("div", { className: specificContainerClassName }, renderCommonFilters(commonFilters, filtersGroupOrder, selectedFilters)),
        typeWithHierarchy && hierarchyFilters.totalCount > 0 && (React.createElement("div", { className: specificContainerClassName }, renderHierarchyFilters(hierarchyFilters, filtersGroupOrder, selectedFilters))),
        typeWithHierarchy && hierarchyLikeFilters.totalCount > 0 && (React.createElement("div", { className: specificContainerClassName }, renderHierarchyFilters(hierarchyLikeFilters, filtersGroupOrder, selectedFilters, false))),
        React.createElement(DropdownOverlay_1.DropdownOverlay, { active: isFilterOpened })));
};
exports.FiltersGroup = FiltersGroup;
